export const APP_STORE_ID = '6767833271';
export const APP_UPSELL_CAMPAIGN = 'app_launch';
export type AppUpsellEntryPoint = 'feed' | 'navigation' | 'portfolio';
export const APP_STORE_URL = 'https://apps.apple.com/us/app/morfi-opinion-markets/id6767833271';

export function isIPhone(userAgent: string): boolean {
  return /iPhone/i.test(userAgent);
}

/** Keep QR scans distinct from on-page clicks and preserve the originating banner. */
export function buildAppDownloadUrl(
  oneLink: string | undefined,
  entryPoint: AppUpsellEntryPoint,
  action: 'direct' | 'dialog_link' | 'qr',
): string {
  if (!oneLink) return APP_STORE_URL;
  const url = new URL(oneLink);
  url.searchParams.set('pid', 'morfi_web');
  url.searchParams.set('c', APP_UPSELL_CAMPAIGN);
  url.searchParams.set('af_channel', 'web_app_upsells');
  url.searchParams.set('af_sub1', entryPoint);
  url.searchParams.set('af_sub2', action);
  return url.toString();
}
